module.exports = __webpack_public_path__ + "static/media/portallogo-2020.5ea4e668.png";